// extracted by mini-css-extract-plugin
export default {"navbarEch":"NavigationLink_navbarEch__I5T7L","menu":"NavigationLink_menu__BfuS5","link":"NavigationLink_link__rQW69","name":"NavigationLink_name__Qc-7H"};